import apiClient from './apiClient';

export const getFeedData = async () => {
  const { data } = await apiClient.get(`/feed`);
  return data;
};
